import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-range.css'
import { RangeProps } from './range.types'

const Range = ({ min, max, step, value, onChange, dataTestId = '' }: RangeProps) => {
  return (
    <input
      data-test={dataTestId}
      type="range"
      className="hot-form__input-range"
      min={min}
      max={max}
      step={step}
      aria-label="range"
      value={value}
      onChange={onChange}
    />
  )
}

export default Range
